import React from 'react';
import { Link, Navigate, Route, Routes } from 'react-router-dom';
import { RequireAnonymous, RequireAuth } from './auth/RequireAuth';
import { useI18n } from './i18n/I18nProvider';
import { Layout } from './components/Layout';
import { AccountPage } from './pages/AccountPage';
import { DayPage } from './pages/DayPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { TodoDetailPage } from './pages/TodoDetailPage';
import { todayKey } from './utils/date';
import './custom.css';

function NotFound() {
  const { t } = useI18n();

  return (
    <div className="empty-state">
      <h1 className="h5">{t('common.notFound')}</h1>
      <Link to="/">{t('common.backToToday')}</Link>
    </div>
  );
}

export default function App() {
  return (
    <Layout>
      <Routes>
        {/* "Hôm nay" được tính lúc điều hướng, theo lịch của máy người dùng chứ không phải của máy chủ. */}
        <Route path="/" element={<Navigate to={`/day/${todayKey()}`} replace />} />

        <Route
          path="/day/:date"
          element={
            <RequireAuth>
              <DayPage />
            </RequireAuth>
          }
        />
        <Route
          path="/todo/:id"
          element={
            <RequireAuth>
              <TodoDetailPage />
            </RequireAuth>
          }
        />
        <Route
          path="/account"
          element={
            <RequireAuth>
              <AccountPage />
            </RequireAuth>
          }
        />

        <Route
          path="/login"
          element={
            <RequireAnonymous>
              <LoginPage />
            </RequireAnonymous>
          }
        />
        <Route
          path="/register"
          element={
            <RequireAnonymous>
              <RegisterPage />
            </RequireAnonymous>
          }
        />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}
